import Controller from '../abstracts/Controller';
import 'scss-templates/t-register.scss';

export default class RegisterController extends Controller {
  static get COMPONENTS() {
    return [
      'RegistrationComponent',
      'RegistrationStep1Component',
      'ChooseCountryLanguageComponent'
    ];
  }
  constructor(compEl) {
    super(compEl);
    console.log('Loading RegistrationController')
  }
}
